import { useCreate } from '../../../../api/react-query';

export function useConfigCreate({ params }) {
  const {
    mutateAsync: createConfig,
    isLoading: isCreating,
    error,
  } = useCreate({
    url: 'config/configs',
    params,
  });

  return {
    createConfig,
    isCreating,
    error,
  };
}
